<template>
    <ModalBase
        name="addLesion"
        :title="'Nueva lesión para ' + deportistaName"
        @close="close"
    >
        <ValidationObserver tag="form" ref="observer" class="tw:flex tw:flex-col tw:gap-4" @submit.prevent="submit">
            <BaseDateInput label="Fecha de baja" name="fecha_baja" id="fecha_baja" rules="required" :value="fecha_baja" @input="fecha_baja = $event" />
            <BaseDateInput label="Fecha de alta" name="fecha_alta" id="fecha_alta" :value="fecha_alta" @input="fecha_alta = $event" />

            <div class="tw:flex tw:flex-col tw:gap-1">
                <label class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-500">Orientación diagnóstica</label>
                <QuillEditor v-model="orientacion_diagnostica"/>
            </div>

            <Button class="tw:justify-center" type="submit" :disabled="loading">Registrar lesión</Button>
        </ValidationObserver>
    </ModalBase>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import QuillEditor from '@/modules/ui/QuillEditor.vue'
    import BaseDateInput from '@/modules/admin/ui/BaseDateInput.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        deportista: {
            type: Object,
            required: true
        },
        onSubmit: {
            type: Function,
            required: true
        }
    })

    const emit = defineEmits(['close'])
    const instance = getCurrentInstance()

    const deportistaName = computed(() => {
        const name = props.deportista.name || props.deportista.nombre || ''
        const surnames = props.deportista.surnames || props.deportista.apellidos || ''
        return [name, surnames].filter(Boolean).join(' ')
    })

    const fecha_baja = ref(null)
    const fecha_alta = ref(null)
    const orientacion_diagnostica = ref(null)
    const loading = ref(false)
    const observer = ref(null)

    const resetForm = () => {
        fecha_baja.value = null
        fecha_alta.value = null
        orientacion_diagnostica.value = null
        observer.value?.reset()
    }

    const close = () => {
        resetForm()
        instance.proxy.$modal.hide('addLesion')
        emit('close')
    }

    const submit = async() => {
        const isValid = await observer.value.validate()
        if (isValid) {
            loading.value = true

            const formData = {
                fecha_baja: fecha_baja.value,
                fecha_alta: fecha_alta.value,
                orientacion_diagnostica: orientacion_diagnostica.value
            }

            try {
                await props.onSubmit(formData)
                close()
            } catch {
                // Error handled by composable via toast
            } finally {
                loading.value = false
            }
        }
    }
</script>
